module.exports = __webpack_public_path__ + "img/join_06.34ff1cef.svg";